import React, { FC } from 'react'

import { FoodForm, FoodFormProps } from './FoodForm'

import { PageLayout } from 'Components'
import SidebarUserFood from 'Components/SidebarUserFood/SidebarUserFood'

type CreateFoodPageProps = FoodFormProps

export const CreateFoodPage: FC<CreateFoodPageProps> = ({ ...foodFormProps }) => {
  return (
    <PageLayout variant="smallcircle">
      <div className="container max-900">
        <div className="row">
          <SidebarUserFood />

          <div className="col-12 col-lg-8">
            <h1>Nahrungsmittel erstellen</h1>

            <p>
              Hier können Sie Ihr eigenes Nahrungsmittel hinterlegen. Füllen Sie einfach die Felder mit den
              Informationen zu Ihrem Nahrungsmittel aus und klicken Sie anschliessend auf «Speichern». Nun können Sie
              Ihr eigenes Nahrungsmittel über die Suche ins Tagebuch eintragen.
            </p>

            <FoodForm {...foodFormProps} />
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
